import { appendIf } from '@btime/helpers'
import { useIsOwner } from '@btime/react-session'
import { useTranslation } from 'react-i18next'

import { useOpenTriggerCallModal } from '../../../utils/routes/modals/modalsActions'
import { useRetryTriggerCall } from '../list/_requests/retryTriggerCall'

export const useTriggerCallsActions = (item, ids, opts = {}) => {
  const { t } = useTranslation('triggerCalls')
  const hide = opts.hide || []
  const isOwner = useIsOwner()

  const openDetailsModal = useOpenTriggerCallModal()
  const [retry, { loading }] = useRetryTriggerCall()

  if (!item && !ids.length) return []

  const singleOptions = [
    ...appendIf(!hide.includes('seeDetails'), {
      value: t('seeDetails'),
      icon: 'BsSearch',
      onClick: () => openDetailsModal(item)
    }),

    ...appendIf(item?.status === 'error', {
      value: t('runManually'),
      icon: 'BsArrowRepeat',
      onClick: () => retry(item.id)
    })
  ]

  const multiOptions = []

  return [!ids || ids.length === 1 ? singleOptions : multiOptions, loading]
}
